import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Message } from 'semantic-ui-react'
import styled from 'styled-components'
import { formatNumber } from '~/utils/helpers'

const StyledMessage = styled(Message)`
background-color: #fcfff5 !important;
color: #2c662d !important;
width: 450px;
margin: 0px !important;
`
interface Props {
  keySilage?: 'grassSilage' | 'maizeSilage'
}

const Kalium:React.FC<Props> = ({ keySilage }) => {
  const { control } = useFormContext()
  const mainKey = keySilage || 'grassSilage'
  const watchField = useWatch({ control, name: `${mainKey}.mineralFertilizers` }) || []

  const sum = watchField.reduce((total, item) => {
    const numericValue = parseFloat(item?.value?.replace(',', '.'));
    const nitroValue = parseFloat(item?.k2o?.replace(',', '.'));
    const nitroTransformed = isNaN(nitroValue) ? 0 : nitroValue
    return total + (isNaN(numericValue) ? 0 : (numericValue * nitroTransformed));
  }, 0)

  return <StyledMessage>
    <Message.Header>{'Ihre Menge an Kalium-Mineraldünger beträgt:'}</Message.Header>
    <Message.Content>{`${formatNumber(sum, 2)} kg K2O/ha`}</Message.Content>
  </StyledMessage>
}
export default Kalium